module.exports = __webpack_public_path__ + "media/wedding-moment.91ec8751.mp4";